import React from 'react';
import Style from './Loading.module.scss';
import { CircularProgress } from 'investira.react.components';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Renderiza o componente Loading.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {string} props.align - Propriedade `align` do componente.
 * @param {*|number|string} props.size - Tamanho aplicado ao componente ou ícone.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
function Loading(props) {
    const xClass = classNames(Style.root, {
        [Style.center]: props.align === 'center',
        [Style.top]: !props.align === 'top'
    });

    return (
        <div className={xClass}>
            <div className={Style.wrap}>
                <CircularProgress size={props.size} />
            </div>
        </div>
    );
}

Loading.propTypes = {
    align: PropTypes.oneOf(['top', 'center']),
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Loading.defaultProps = {
    align: 'center',
    size: 40
};

export default Loading;
